import React from 'react';
import { useSelector } from 'react-redux';
import * as Styles from './tooltipstyles';

export default function Tooltip() {
  const visible = useSelector((state) => state.tooltip.visible);
  const fragment = useSelector((state) => state.tooltip.data);

  const tooltipWidth = 240;
  const tooltipHeightFull = 130;
  // const width = tooltipWidth - 40;
  // const height = tooltipHeightFull - 60;

  let xP = fragment?.leftBounds + fragment?.x - tooltipWidth * 0.5;
  let yP = -tooltipHeightFull + fragment?.y;

  yP -= 10;

  if (xP < 10) {
    xP = 10;
  }

  console.log('fragment ', fragment);
  console.log('x ', xP);
  console.log('y', yP);

  const style = {
    display: visible ? 'flex' : 'none',
    transform: `translate(${xP}px,${yP}px)`,
    height: tooltipHeightFull,
  };

  return (
    <Styles.TooltipStyles>
      <div className="tool-tip" style={style}>
        <h4>{fragment?.data?.n}</h4>
        <h5>{fragment?.data?.pn}</h5>
        <div className="place">{fragment?.data?.pl}</div>
        <div className="tiny">VOTES: {fragment?.data?.vo}</div>
        <div className="tiny">
          ELECTED: {fragment?.data?.el === 'N' ? 'No' : 'Yes'}
        </div>
      </div>
    </Styles.TooltipStyles>
  );
}
